export default{
    getSettings() {
        return this.$axios.$get(
            this.$api.user.appConfig.getSettings
        )
    },
    setSettings({}, param) {
        return this.$axios.$post(
            this.$api.user.appConfig.setSettings,
            param
        )
    },
}
